// extracted by mini-css-extract-plugin
export default {"badge":"ThemeBadge_badge__rAm+6"};